// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"52a827b7","796":"db8187fc"}[chunkId] + ".chunk.js";
};